<template>
  <div style="height: 100vh;min-height: 685px;">
    <div class="centen">
      <!--用户输入账户名和验证码-->
      <div class="accountEntry" v-if="accountStep">
        <h5><i class="el-icon-info"></i> 请输入您需要重置登录密码的账户名</h5>
        <ul>
          <li style="margin-top: 15px;">
            <span>园区名称</span>
            <el-input placeholder="园区名称" v-model="yqAppCode" size="mini">
            </el-input>
          </li>
          <li style="margin-top: 15px;">
            <span>用户名</span>
            <el-input placeholder="用户名" v-model="accountName" size="mini">
            </el-input>
          </li>
          <li class="code-li" style="margin-top: 15px;">
            <span>验证码</span>
            <el-input placeholder="验证码" v-model="code"
                      @keyup.13.native="sendSms" size="mini">
            </el-input>
            <i class="codeImg" @click="chageCode">{{ checkCode }}</i>
          </li>
          <li class="prompt" style="margin-top: 5px;">
            <b v-html="promotPro"></b>
          </li>
          <li style="margin-top: 10px;">
            <router-link :to="login" class="btn">返回</router-link>
            <a @click="sendSms" class="btn">下一步</a>
          </li>
        </ul>
      </div>
      <!--用户输入短信校验码-->
      <div class="accountEntry" v-if="checkStep">
        <h5><i class="el-icon-info"></i> 请输入您收到的短信校验码</h5>
        <ul>
          <li>
            <span>手机号码</span>
            <span id="user_phone">{{phone}}</span>
          </li>
          <li class="code-li">
            <span>校验码</span>
            <el-input placeholder="校验码" v-model="verifyCode"
                      @keyup.13.native="checkSms" size="mini" maxlength="6" onkeypress=" return event.keyCode>=48&&event.keyCode<=57" ng-pattern="/[^a-zA-Z]/">
            </el-input>
            <button-sms :phoneNumber="phone"
                        @clearVerifyCode="verifyCode = ''" style="margin-left: 10px" />
          </li>
          <li class="prompt">
            <b v-html="promotPro"></b>
          </li>
          <li>
            <a @click="checkSms" class="btn">下一步</a>
          </li>
        </ul>
      </div>
      <!--用户重置密码-->
      <div class="accountEntry" v-if="resetStep">
        <h5><i class="el-icon-info"></i> 请输入您的重置密码</h5>
        <ul>
          <li>
            <span>重置密码</span>
            <el-input placeholder="重置密码" v-model="password" size="mini" :maxlength=20 type="password"
                      @keyup.13.native="resetPassword">
            </el-input>
          </li>
          <li>
            <span>确认密码</span>
            <el-input placeholder="确认密码" v-model="confirm" size="mini" :maxlength=20 type="password"
                      @keyup.13.native="resetPassword">
            </el-input>
          </li>
          <li class="prompt">
            <b v-html="promotPro"></b>
          </li>
          <li>
            <a @click="resetPassword" class="btn">重置</a>
          </li>
        </ul>
      </div>
    </div>
    <footer>Copyright © 2017，Damai-IoT，All Rights Reserved | 浙ICP备18001529号</footer>
  </div>
</template>

<script>
  import ButtonSms from '../components/common/buttons/button-sms'
  import {api} from './api/Login'
  import {pattern} from '../utils/regular'
  import md5 from 'js-md5'
  import {errorHandler} from '../utils/errorHandler'
  import {nSuccess} from '../utils/notice'
  import {bus} from '../utils/bus'

  export default {
    /* eslint-disable */
    components: {ButtonSms},
    name: 'reset-password',
    data () {
      return {
        accountStep: true,
        checkStep: false,
        resetStep: false,
        login: '',
        yqAppCode: '',
        accountName: '',
        checkCode: '',
        promotPro: '',
        code: '',
        phone: '',
        password: '',
        confirm: '',
        verifyCode: ''
      }
    },
    created: function () {
      window.sessionStorage.setItem('token', '')
      bus.global.token = ''
      this.login = '/login'
      this.chageCode()
    },
    methods: {
      sendSms: function () {
        if (!this.accountName) {
          this.promotPro = '<b>请输入用户名</b>'
          return false
        } else {
          this.promotPro = ''
        }
        if (this.code.toLowerCase() === this.checkCode.toLowerCase()) {
          window.sessionStorage.setItem('yqCode', this.yqAppCode)
          bus.global.yqCode = this.yqAppCode
          this.$axios.post(`${api.getPhone}`, {
            name: this.accountName
          })
            .then(res => {
              this.accountStep = false
              this.checkStep = true
              this.phone = res.data.data
            })
            .catch(errorHandler('获取手机号失败'))
        } else {
          if (!this.code) {
            nSuccess('请输入验证码')
            this.chageCode()
          } else {
            nSuccess('验证码不正确')
            this.chageCode()
          }
        }
      },
      checkSms: function () {
        if (!this.verifyCode) {
          this.promotPro = '<b>请输入短信校验码</b>'
          return false
        } else {
          this.promotPro = ''
        }
        this.$axios.post(`${api.checkVerificationCode}`, {
          phone: this.phone,
          identityCode: this.verifyCode,
        })
          .then(res => {
            this.resetStep = true
            this.checkStep = false
          })
          .catch(errorHandler('短信校验失败'))
      },
      resetPassword: function () {
        let flagP = pattern.password.test(this.password)
        let accountName = this.accountName.toLowerCase()
        let pw = this.password + accountName
        let once = md5(pw) + accountName
        let pwd
        for (let i = 0; i < 9; i++) {
          pwd = md5(once)
          once = pwd + accountName
        }
        if (!this.password) {
          nSuccess('请输入重置密码')
          return false
        }
        if (this.password.length < 6 && 0 < this.password.length) {
          nSuccess('密码不得少于6位')
          return false
        }
        if (!this.confirm) {
          nSuccess('请再次核对密码')
          return false
        }
        if (this.confirm !== this.password) {
          nSuccess('两次密码不一致')
          return false
        }
        if (this.password && !flagP) {
          nSuccess('密码必须由字母，数字，符号组成')
          return false
        } else {
          this.promotPro = ''
        }
        this.$axios.post(`${api.resetPassWord}`, {
          name: this.accountName,
          password: pwd
        })
          .then(res => {
            nSuccess('重置成功')
            this.resetStep = true
            this.checkStep = false
            this.$router.push({
              name: 'login'
            })
          })
          .catch(errorHandler('重置失败'))
      },
      chageCode: function () {
        let code = ''
        let codeLength = 4
        let random = new Array(0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R',
          'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z')
        for (var i = 0; i < codeLength; i++) {
          var index = Math.floor(Math.random() * 36)
          code += random[index]
        }
        this.checkCode = code
      }
    }
  }
</script>

<style scoped>
  .head img {
    width: 250px;
    height: 44px;
    margin: 15px 10px 15px 30px;
  }
  .centen {
    width: 100%;
    height: 90%;
    background-color: #EFF1F5;
    position: relative;
  }
  .accountEntry {
    width: 480px;
    height: 280px;
    padding: 20px;
    position: absolute;
    top: 120px;
    left: 0;
    right: 0;
    margin: 0 auto;
    background: white;
    border: 1px solid #E6E6E6;
  }

  h5 {
    color: #4D4D4D;
    font-weight: 400;
    margin: 0;
    padding-bottom: 15px;
    border-bottom: 1px solid #eeeeee;
  }

  h5 i {
    color: #00A0E6;
  }

  .code-li .el-input {
    width: 180px;
  }

  .codeImg {
    display: inline-block;
    width: 100px;
    height: 28px;
    margin-left: 10px;
    vertical-align: bottom;
    padding: 5px 10px;
    letter-spacing: 14px;
    background-image: url('../assets/code.jpg');
    background-size: 100% 100%;
  }

  .codeImg:hover {
    cursor: pointer;
  }

  #user_phone {
    margin-left: 10px;
    width: 160px;
    text-align: left;
    color: #00A0E6;
  }

  .accountEntry li {
    padding: 0 33px;
    margin-top: 25px;
    text-align: left;
    display: flex;
    align-items: center;
  }

  .accountEntry li span {
    display: inline-block;
    width: 60px;
    text-align: right;
  }

  .accountEntry li:last-child {
    display: flex;
    justify-content: space-between;
    padding: 0 60px;
  }

  .prompt b {
    display: block;
    width: 100%;
    text-align: center;
    color: red;
    margin-top: 8px;
    margin-bottom: -5px;
  }

  .btn {
    display: block;
    width: 90px;
    margin: 0 auto;
    color: #FFFFFF;
    border-radius: 5px;
    text-align: center;
    background-color: #00A0E6;
    padding: 5px 10px;
  }

  .el-input {
    margin-left: 10px;
    width: 80%;
  }

  footer {
    width: 100%;
    font-size: 13px;
    text-align: center;
    color: #999999;
    background-color: #F0F3F7;
    height: 10vh;
    line-height: 35px;
  }
</style>



// WEBPACK FOOTER //
// src/view/resetPassword.vue